import React, { useState, useMemo, useEffect } from 'react';
import { isEmpty } from 'lodash';
import moment from 'moment';
import Table from '@material-ui/core/Table';
import {
  CssBaseline,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core';
import { useTable } from 'react-table';

import '../index.css';
import ErrorLogsModal from './ErrorLogsModal';

const ErrorLogsTable = ({ tableData }) => {
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState({});

  const headers = useMemo(
    () => [
      {
        Header: 'ErrorLogsTable',
        columns: [
          { Header: 'Bot', accessor: 'botName' },
          { Header: 'Bloco', accessor: 'itemType' },
          { Header: 'Tipo de erro', accessor: 'errorType' },
          { Header: 'Descrição', accessor: 'description' },
          {
            Header: 'Data',
            accessor: 'date',
            Cell: ({ cell }) =>
              moment(cell?.row?.values?.date)
                .format('DD/MM/YYYY HH:mm')
                .toString(),
          },
          {
            Header: 'Detalhes',
            accessor: 'details',
            Cell: ({ cell }) => {
              return (
                <span
                  className="error-logs-cell-details"
                  onClick={() => {
                    setModalData(cell?.row?.original);
                    setShowModal(true);
                  }}
                >
                  {cell?.row?.values?.details}
                </span>
              );
            },
          },
        ],
      },
    ],
    []
  );

  const { getTableProps, headerGroups, rows, prepareRow } = useTable({
    columns: headers,
    data: tableData,
  });

  useEffect(() => {
    if (!showModal && !isEmpty(modalData)) {
      setModalData({});
    }
  }, [modalData]);

  const renderTableHeaders = () => {
    if (!Array.isArray(headerGroups) || !headerGroups[1]) {
      return false;
    }

    const headerGroup = headerGroups[1];

    return (
      <TableRow {...headerGroup.getHeaderGroupProps()}>
        {headerGroup.headers.map((column) => (
          <TableCell {...column.getHeaderProps()}>
            {column.render('Header')}
          </TableCell>
        ))}
      </TableRow>
    );
  };

  const renderTableBody = () => {
    return rows.map((row) => {
      prepareRow(row);
      return (
        <TableRow {...row.getRowProps()}>
          {row.cells.map((cell) => (
            <TableCell {...cell.getCellProps()}>
              {cell.render('Cell')}
            </TableCell>
          ))}
        </TableRow>
      );
    });
  };

  return (
    <>
      <CssBaseline />
      <div className="error-logs-table-container">
        <Table className="error-logs-page-table" {...getTableProps()}>
          <TableHead>{renderTableHeaders()}</TableHead>
          <TableBody>{renderTableBody()}</TableBody>
        </Table>
      </div>
      <div>
        <ErrorLogsModal
          data={modalData}
          show={showModal}
          setShow={setShowModal}
        />
      </div>
    </>
  );
};

export default ErrorLogsTable;
